export const adaptDireccionPaciente = (direccionPaciente, idEvaluacion, idPaciente) => {
    return {
        idEvaluacion: idEvaluacion,
        idPaciente: idPaciente,
        codigoSAPPaciente: direccionPaciente.codigoSAP,
        idLugarRI: direccionPaciente.idLugarRI,
        latitud: direccionPaciente.latitud?.toString(),
        longitud: direccionPaciente.longitud?.toString(),
        direccionPaciente: {
            direccion: direccionPaciente?.direccion,
            localidad: direccionPaciente?.localidad,
            provincia: direccionPaciente?.provincia,
            codigoPostal: direccionPaciente?.codigoPostal,
            observacion: direccionPaciente?.observacionExtra
        },
        direccionLugarServicio: {
            direccion: direccionPaciente?.direccionInstitucion,
            localidad: direccionPaciente?.localidadInstitucion,
            provincia: direccionPaciente?.provinciaInstitucion,
            codigoPostal: direccionPaciente?.codigoPostalInstitucion,
            observacion: direccionPaciente?.habitacion
        }
    }
} 